import { setupWorker } from "msw";
import { allHandlers } from "./handlers";

export const worker = setupWorker(...allHandlers);
